module.exports = __webpack_public_path__ + "img/shareratio.b5a12ee4.png";